<script setup lang="ts">
import { WEB_APP_URL } from '~/constants/website'

useDefaultMeta({
  title: 'Aplikasi Kirim Paket COD Terbaik #1 Indonesia | KiriminAja',
  description:
    'Kirim paket ke seluruh Indonesia dengan pengiriman reguler KiriminAja! Ekspedisi terlengkap, bisa COD, &amp; tanpa minimum jumlah kiriman. Kirim sekarang!',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apa itu pembayaran COD?',
    answer:
      '<p>Pembayaran COD (Cash on Delivery) adalah metode di mana paket dibayar setelah barang diterima. KiriminAja mempermudah proses ini dengan pencairan dana yang cepat ke saldo aktif.</p>'
  },
  {
    question: 'Berapa lama dana COD cair di KiriminAja?',
    answer:
      '<p>Dana COD akan dirilis ke saldo aktif di hari yang sama setelah paket diterima. Dana ini bisa langsung ditarik ke rekening secara real-time.</p>'
  },
  {
    question: 'Apa itu COD Advance di KiriminAja?',
    answer:
      '<p>COD Advance adalah layanan percepatan pencairan dana COD, hingga 50% nilai COD lebih awal, bahkan saat paket masih dalam perjalanan.</p>'
  },
  {
    question: 'Apakah semua ekspedisi mendukung pembayaran COD?',
    answer:
      '<p>Ya, KiriminAja bekerja sama dengan banyak ekspedisi ternama yang mendukung metode pembayaran COD untuk mempermudah pengiriman.</p>'
  },
  {
    question:
      'Bagaimana jika saya tidak menggunakan marketplace, apakah masih bisa menggunakan COD?',
    answer:
      '<p>Tentu saja! KiriminAja memungkinkan siapapun bisa menggunakan layanan COD tanpa harus bergabung dengan marketplace tertentu.</p>'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Pelanggan Bayar di Tempat, Proses Cairnya Cepat"
      sub-title="Kirim Paket dengan Pembayaran COD"
      description="Tak perlu lagi menunggu dana COD-mu berhari-hari, KiriminAja bantu cairkan di hari yang sama setelah paketmu diterima oleh pelanggan."
      hero-image="/images/batch-2/cod-welcome.avif"
      button-label="Kirim Paket Sekarang"
      :button-link="$utm.utmUrl(WEB_APP_URL)"
    />
    <SolusiCodBenefit />
    <SolusiCodCaraRilisDana />
    <SolusiCodDanaCod />
    <SolusiCodCaraKerja />
    <FaqBase :faqs="faqs" />
    <CtaSection />
  </div>
</template>
